import { selector } from "recoil";
import { templateTableStateAtom,templateSummaryTableStateAtom } from ".";
import APIService from "../../APIService";
import { Apis } from "../../app.constants";
import { RecoilAtomKey } from "../../recoilConstantKey";
import { generateFilterKey } from "../../../utils/helper";

export const fetchTemplateListSelector = selector({
  key: RecoilAtomKey.fetchTemplateListSelectorKey,
  get: async ({ get }) => {
    const state = get(templateTableStateAtom);
    const filterKey = generateFilterKey(state.filters);
    // ✅ Check if data is already cached
    if (state.cache[filterKey]) {
      return {
        data: state.cache[filterKey],
        totalCount: state.totalCountCache[filterKey],
        fromCache: true,
      };
    }

    try {
      const response = await APIService.get(
        `${Apis.getWhatsappTemplate}?next_page=${state.filters.page + 1}&search=${state.filters.search}&sort_field=${state.filters.sortField}&sort_order=${state.filters.sortOrder}&category=${state.filters.category}&bot_number=${state.filters.botNumber}&limit=${state.filters.limit || 10}&company_id=${state.filters.organisation || ''}&status=${state.filters.status || ''}`
      );

      const payload = response?.data ?? response;
      const templateData =
        payload?.results ??
        payload?.list ??
        payload?.data?.results ??
        payload?.data?.list ??
        [];
      const totalCount =
        payload?.total_count ??
        payload?.count ??
        payload?.data?.total_count ??
        payload?.data?.count ??
        0;

      return {
        data: Array.isArray(templateData) ? templateData : [],
        totalCount,
        fromCache: false,
      };
    } catch (error) {
      return { data: [], totalCount: 0, fromCache: false };
    }
  },
});

export const fetchTemplateSummarySelector = selector({
  key: RecoilAtomKey.fetchTemplateSummarySelectorKey,
  get: async ({ get }) => {
    const state = get(templateSummaryTableStateAtom);
    const filterKey = generateFilterKey(state.filters);
    // ✅ Check if data is already cached
    if (state.cache[filterKey]) {
      return {
        ...state, 
        data: state.cache[filterKey], 
        totalCount: state.totalCountCache[filterKey], 
        fromCache: true 
      };
    }

    try {
      if(state?.filters?.template_id){
        const response = await APIService.get(`${Apis.getTemplateDateWiseSumnary}?template_id=${state?.filters?.template_id}&start_date=${state?.filters?.start_date || ''}&end_date=${state?.filters?.end_date || ''}&next_page=${state?.filters?.page || 0}&sort_by=${state?.filters?.sort_by || ''}&order=${state?.filters?.order || ''}&limit=${state?.filters?.limit || 10}`);
        if(response?.status===200){
          return {
            ...response?.data,
            data: response?.data?.data || [],
            totalCount: response?.data?.total_count || 0,
            fromCache: false
          };  
        } else {
          return { data: [], totalCount: 0, fromCache: false };
        }  
      } else {
        return { data: [], totalCount: 0, fromCache: false };
      }
    } catch (error) {
      return { data: [], totalCount: 0, fromCache: false };
    }
  },
});
